import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IsNotLoggedGuard } from "./providers/guards/is-not-logged.guard";
import { UserIsNotActiveGuard } from "./providers/guards/user-is-not-active.guard";
import { ProjectIsSelectGuard } from "./providers/guards/project-is-select.guard";
import { HomePathGuard } from "./providers/guards/home-path.guard";
import { userAccessToPageGuard } from "./providers/guards/user-access-to-page.guard";


const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
        path: 'auth',
        loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule),
        canActivate: []
    },
    {
        path: 'home',
        loadChildren: () => import('./pages/home-page/home-page.module').then(m => m.HomePageModule),
        canActivate: [IsNotLoggedGuard, UserIsNotActiveGuard, userAccessToPageGuard,]
    },
    {
        path: 'user',
        loadChildren: () => import('./pages/user/user.module').then(m => m.UserModule),
        canActivate: [IsNotLoggedGuard, UserIsNotActiveGuard]
    },
    {
        path: 'project',
        loadChildren: () => import('./pages/project/project.module').then(m => m.ProjectModule),
        canActivate: [IsNotLoggedGuard, UserIsNotActiveGuard]
    },
    {
        path: 'rooms',
        loadChildren: () => import('./pages/rooms/rooms.module').then(m => m.RoomsModule),
        canActivate: [IsNotLoggedGuard, UserIsNotActiveGuard, userAccessToPageGuard,]
    },
    {
        path: 'element',
        loadChildren: () => import('./pages/management-elements/management-elements.module').then(m => m.ManagementElementsModule),
        canActivate: [IsNotLoggedGuard, UserIsNotActiveGuard, userAccessToPageGuard,]
    },
    {
        path: 'device-iot',
        loadChildren: () => import('./pages/device-iot/device-iot.module').then(m => m.DeviceIotModule),
        canActivate: [IsNotLoggedGuard, UserIsNotActiveGuard, userAccessToPageGuard,]
    },
    {
        path: 'sensor-event',
        loadChildren: () => import('./pages/sensor-event/sensor-event.module').then(m => m.SensorEventModule),
        canActivate: [IsNotLoggedGuard, UserIsNotActiveGuard, userAccessToPageGuard,]
    },
    {
        path: 'notifications',
        loadChildren: () => import('./pages/notification/notification.module').then(m => m.NotificationModule),
        canActivate: [IsNotLoggedGuard, UserIsNotActiveGuard, userAccessToPageGuard,]
    },
    {
        path: 'industry',
        loadChildren: () => import('./pages/industry/industry.module').then(m => m.IndustryModule),
        canActivate: [IsNotLoggedGuard, UserIsNotActiveGuard, userAccessToPageGuard]
    },
    {
        path: 'import-sensor-data',
        loadChildren: () => import('./pages/import-sensor-data-values/import-sensor-data-values.module').then(m => m.ImportSensorDataValuesModule),
        canActivate: [IsNotLoggedGuard, UserIsNotActiveGuard, userAccessToPageGuard,]
    }, {
        path: 'import',
        loadComponent: () => import('./pages/import-global/import-global.component').then(c => c.ImportGlobalComponent),
        canActivate: [IsNotLoggedGuard, UserIsNotActiveGuard]
    },
    {
        path: 'dash-board',
        loadComponent: () => import('./pages/dash-board/dash-board.component').then(c => c.DashBoardComponent),
        canActivate: [IsNotLoggedGuard, UserIsNotActiveGuard, userAccessToPageGuard,]
    },
    {
        path: 'kpi',
        loadComponent: () => import('./pages/kpipage/kpipage.component').then(c => c.KPIpageComponent),
        canActivate: [IsNotLoggedGuard, UserIsNotActiveGuard, userAccessToPageGuard,]
    }, {
        path: 'calendar',
        loadComponent: () => import('./pages/calendar-page/calendar-page.component').then(c => c.CalendarPageComponent),
        canActivate: [IsNotLoggedGuard, UserIsNotActiveGuard, userAccessToPageGuard,]
    },
    {
        path: 'analytics',
        loadComponent: () => import('./pages/analytics/analytics.component').then(c => c.AnalyticsComponent),
        canActivate: [IsNotLoggedGuard, UserIsNotActiveGuard, userAccessToPageGuard]
    },
    {
        path: 'maintenance-report',
        loadComponent: () => import('./pages/maintenance-report-page/maintenance-report-page.component').then(c => c.MaintenanceReportPageComponent),
        canActivate: [IsNotLoggedGuard, UserIsNotActiveGuard, userAccessToPageGuard]
    },
    {
        path: 'anonymous-action',
        loadChildren: () => import('./pages/external-action/external-action.module').then(m => m.ExternalActionModule),
    },
    // {
    //     path: 'action-edge-device',
    //     loadComponent: () => import('./pages/action-edge-device/action-edge-device.component').then(c => c.ActionEdgeDeviceComponent),
    //     canActivate: [IsNotLoggedGuard, UserIsNotActiveGuard, userAccessToPageGuard,]
    // },
    {
        path: '**',
        redirectTo: 'home',
    },

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
